var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7507 22.4167V23.5C12.7507 25.295 14.2057 26.75 16.0007 26.75C17.7956 26.75 19.2507 25.295 19.2507 23.5V22.4167M12.7507 22.4167L19.2507 22.4167M12.7507 22.4167L8.41755 22.4168C7.86198 22.4168 7.40385 21.9986 7.34127 21.4598L7.33398 21.3331V20.6986C7.33398 20.4113 7.44821 20.1362 7.65137 19.9329L8.20467 19.3794C8.34082 19.2432 8.41732 19.0587 8.41732 18.8661V14.8332C8.41732 12.8381 9.18778 11.0229 10.4474 9.66899M19.2507 22.4167L23.5839 22.4167M8.41732 7.25L25.7507 24.5833M23.5835 18.0823L23.5844 14.8333C23.5844 10.6452 20.1893 7.25 16.0012 7.25L15.7404 7.2544C14.8684 7.28386 14.0338 7.46021 13.2606 7.76005",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOff);
export default __webpack_public_path__ + "static/media/bell-off.4b7a591633f7cb369f2ef10928b11fd4.svg";
export { ForwardRef as ReactComponent };